// extracted by mini-css-extract-plugin
export default {"content":"style_content__Lhuuu","leftSide":"style_leftSide__3NZgu","rightSide":"style_rightSide__i98hM","type":"style_type__nZwEM"};